import { useState } from "react";
import { Input, Button, Typography, message } from "antd";
import { useGetAllUsers } from "../utils/queryUtils";
import useFetch from "../_fetch";
import { user_role } from "../consts";
import UserInfo from "../components/userInfo";

export default function BulkAssignClients({ queryIds, onSuccess }) {
  const [search, setSearch] = useState('');
  const [chosenUserIds, setChosenUserIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const _fetch = useFetch();

  const userData = useGetAllUsers()?.data;
  const all_users = userData?.data;

  const filtered = all_users
    ?.filter(u => u.role === user_role.PRIMARY_CLIENT)
    ?.filter(u =>
      `${u.first_name} ${u.last_name} ${u.email}`
        .toLowerCase().includes(search.toLowerCase())
    );

  const toggle = (id) =>
    setChosenUserIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );

  const handleSend = async () => {
    if (!chosenUserIds.length) return;
    setLoading(true);
    try {
      const res = await _fetch(
        `${process.env.REACT_APP_API_URL}/query/bulk_assign_primary_client`,
        {
          method: "POST",
          body: {
            queryIds,
            userIds: chosenUserIds,
          },
        }
      );
      const data = await res.json();
      if (data.success) {
        message.success(data.message);
        onSuccess();
      } else {
        message.error(data.message || "Something went wrong");
      }
    } catch (err) {
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
        Assigning {queryIds.length} quer{queryIds.length === 1 ? 'y' : 'ies'} to selected clients
      </Typography.Text>
      <Input
        placeholder="Search clients..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ marginBottom: 8 }}
      />
      <div style={{
        maxHeight: 320,
        overflowY: 'auto',
        border: '1px solid #f0f0f0',
        borderRadius: 8,
        padding: 8
      }}>
        {filtered?.map(u => (
          <div
            key={u._id}
            onClick={() => toggle(u._id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '6px 4px',
              cursor: 'pointer',
              borderRadius: 6,
              background: chosenUserIds.includes(u._id) ? '#e6f4ff' : 'transparent'
            }}
          >
            <input type="checkbox" readOnly checked={chosenUserIds.includes(u._id)} />
            <UserInfo firstName={u.first_name} lastName={u.last_name} email={u.email} />
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
        <Button
          type="primary"
          loading={loading}
          disabled={!chosenUserIds.length}
          onClick={handleSend}
        >
          Send Invite
        </Button>
      </div>
    </div>
  );
}